export default __webpack_public_path__ + "static/media/edit-icon.e954099b.svg";